export const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1200 },
      items: 5,
     },
    tablet: {
      breakpoint: { max: 767, min: 481 },
      items: 4,
    },
    mobile: {
      breakpoint: { max: 480, min: 0 },
      items: 1,
    }
  };